"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInnerPath = function (data, rx, ry, height, ir) {
    var startAngle = (data.startAngle < Math.PI ? Math.PI : data.startAngle);
    var endAngle = (data.endAngle < Math.PI ? Math.PI : data.endAngle);
    var sx = ir * rx * Math.cos(startAngle);
    var sy = ir * ry * Math.sin(startAngle);
    var ex = ir * rx * Math.cos(endAngle);
    var ey = ir * ry * Math.sin(endAngle);
    return "M " + sx + " " + sy + " A " + ir * rx + " " + ir * ry + " 0 0 1 " + ex + " " + ey + " L " + ex + " " + (height + ey) + " A " + ir * rx + " " + ir * ry + " "
        + ("0 0 0 " + sx + " " + (height + sy) + " z");
};
